// extracted by mini-css-extract-plugin
export default {"Actions":"Actions_Actions__cTKxU","new-slide":"Actions_new-slide__swNTg","delete-slide":"Actions_delete-slide__Cj9x2","disabled":"Actions_disabled__pEhaD"};